/* ══════════════════════════════════════════════════════════════════
   BRUTAL-CART.JS — Standalone cart drawer controller
   Pairs with: snippets/brutal-cart.liquid, assets/brutal.css
   All selectors use brutal-mc-* classes / #brutal-cart IDs.
   ══════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── DOM refs ── */
  var drawer   = document.getElementById('brutal-cart');
  var overlay  = document.getElementById('brutal-cart-overlay');
  var countEl  = document.getElementById('brutal-cart-count');

  if (!drawer) return; // brutal cart not in DOM — bail

  var isOpen = false;

  /* ══════════════════════════════════════
     OPEN / CLOSE
     ══════════════════════════════════════ */

  function open() {
    if (isOpen) return;
    isOpen = true;
    drawer.classList.add('brutal-mc--open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('brutal-mc-overlay--open');
    document.body.classList.add('brutal-mc-lock');

    // Update header toggle aria
    var toggle = document.querySelector('[data-action="toggle-mini-cart"]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');

    // Hide Podium widget if present
    var podium = document.getElementById('podium-website-widget');
    if (podium) podium.style.display = 'none';

    drawer.focus();
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('brutal-mc--open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('brutal-mc-overlay--open');
    document.body.classList.remove('brutal-mc-lock');

    var toggle = document.querySelector('[data-action="toggle-mini-cart"]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');

    var podium = document.getElementById('podium-website-widget');
    if (podium) podium.style.display = '';
  }

  function toggle() {
    isOpen ? close() : open();
  }

  /* ══════════════════════════════════════
     INTERCEPT EXISTING CART TOGGLE
     Capture phase — runs before theme.js
     ══════════════════════════════════════ */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action="toggle-mini-cart"]');
    if (btn) {
      e.preventDefault();
      e.stopImmediatePropagation();
      toggle();
    }
  }, true);

  /* ── Close button inside drawer ── */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-action="close-brutal-cart"]')) {
      close();
    }
  });

  /* ── Overlay click ── */
  if (overlay) {
    overlay.addEventListener('click', close);
  }

  /* ── Escape key ── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) close();
  });

  /* ── .mini-cart-close (legacy close button class from old header) ── */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.mini-cart-close')) {
      close();
    }
  });

  /* ══════════════════════════════════════
     SOCIAL PROOF (random count injection)
     ══════════════════════════════════════ */

  function populateSocialProof() {
    var el = drawer.querySelector('.brutal-mc__social-proof');
    if (!el) return;
    var min = parseInt(el.getAttribute('data-min-count') || '8', 10);
    var max = parseInt(el.getAttribute('data-max-count') || '25', 10);
    var tmpl = el.getAttribute('data-copy-template') || '';
    if (!tmpl) return;
    var n = Math.floor(Math.random() * (max - min + 1)) + min;
    var textEl = el.querySelector('[data-social-proof-text]');
    if (textEl) textEl.textContent = tmpl.replace('{count}', n);
  }

  /* ══════════════════════════════════════
     RECENTLY VIEWED (localStorage history)
     ══════════════════════════════════════ */

  var RV_KEY = 'rush_recently_viewed_v1';
  var RV_LIMIT = 8;

  function trackRecentlyViewed() {
    // Track on PDP visits — read product handle/data from product-news section if present
    var productMetaEl = document.querySelector('[data-product-handle]');
    if (!productMetaEl) return;
    var handle = productMetaEl.getAttribute('data-product-handle');
    if (!handle) return;
    var data = {
      handle: handle,
      title: productMetaEl.getAttribute('data-product-title') || '',
      price: productMetaEl.getAttribute('data-product-price') || '',
      image: productMetaEl.getAttribute('data-product-image') || ''
    };
    var stored;
    try { stored = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { stored = []; }
    stored = stored.filter(function (p) { return p.handle !== handle; });
    stored.unshift(data);
    if (stored.length > RV_LIMIT) stored = stored.slice(0, RV_LIMIT);
    try { localStorage.setItem(RV_KEY, JSON.stringify(stored)); } catch (e) {}
  }

  function populateRecentlyViewed() {
    var container = drawer.querySelector('[data-cart-recently-viewed]');
    var row = drawer.querySelector('[data-cart-recently-viewed-row]');
    if (!container || !row) return;
    var stored;
    try { stored = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { stored = []; }
    // Filter out items currently in the cart
    var cartProductIds = (drawer.querySelector('.brutal-mc__upsells-api') || {}).getAttribute
      ? (drawer.querySelector('.brutal-mc__upsells-api').getAttribute('data-cart-products') || '').split(',').filter(Boolean)
      : [];
    if (!stored.length) {
      container.style.display = 'none';
      return;
    }
    container.style.display = '';
    while (row.firstChild) row.removeChild(row.firstChild);
    stored.slice(0, 6).forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'brutal-mc__rv-card';
      a.href = '/products/' + p.handle;
      var img = document.createElement('div');
      img.className = 'brutal-mc__rv-card-img';
      if (p.image) img.style.backgroundImage = 'url(' + JSON.stringify(p.image) + ')';
      a.appendChild(img);
      var info = document.createElement('div');
      info.className = 'brutal-mc__rv-card-info';
      var title = document.createElement('div');
      title.className = 'brutal-mc__rv-card-title';
      title.textContent = p.title;
      info.appendChild(title);
      if (p.price) {
        var price = document.createElement('div');
        price.className = 'brutal-mc__rv-card-price';
        price.textContent = p.price;
        info.appendChild(price);
      }
      a.appendChild(info);
      row.appendChild(a);
    });
  }

  // Track on page load
  trackRecentlyViewed();
  populateSocialProof();
  populateRecentlyViewed();

  /* ══════════════════════════════════════
     VIEW TOGGLE (cart ⇄ wishlist)
     ══════════════════════════════════════ */

  function setView(view) {
    var v = view === 'wishlist' ? 'wishlist' : 'cart';
    drawer.classList.toggle('brutal-mc--view-wishlist', v === 'wishlist');

    var pills = drawer.querySelectorAll('[data-action="brutal-cart-view-toggle"]');
    pills.forEach(function (p) {
      var isActive = p.getAttribute('data-view') === v;
      p.classList.toggle('is-active', isActive);
      p.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    var wishlistView = drawer.querySelector('.brutal-mc__wishlist-view');
    if (wishlistView) wishlistView.hidden = v !== 'wishlist';

    if (v === 'wishlist') ensureSwymRendered();
  }

  function showSwymError(container) {
    while (container.firstChild) container.removeChild(container.firstChild);
    var p = document.createElement('p');
    p.className = 'brutal-mc__wishlist-error';
    p.textContent = 'Couldn’t load your wishlist. Please try again later.';
    container.appendChild(p);
  }

  function ensureSwymRendered() {
    var container = document.getElementById('swym-wishlist-render-container');
    if (!container || container.dataset.swymRendered === '1') return;
    container.dataset.swymRendered = '1';

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      try {
        var qp = (swat && swat.utils && swat.utils.getEncodedAsObject)
          ? swat.utils.getEncodedAsObject(window.location.search)
          : {};
        swat.ui.renderWishlistInContainer(container, qp);
      } catch (err) {
        showSwymError(container);
        container.dataset.swymRendered = '0';
        if (window.console) console.warn('[brutal-cart] Swym render failed:', err);
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action="brutal-cart-view-toggle"]');
    if (!btn) return;
    e.preventDefault();
    setView(btn.getAttribute('data-view') || 'cart');
  });

  /* ══════════════════════════════════════
     QUANTITY UPDATE (AJAX)
     ══════════════════════════════════════ */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action="brutal-cart-qty"]');
    if (!btn) return;

    e.preventDefault();
    var line = btn.getAttribute('data-line');
    var qty  = parseInt(btn.getAttribute('data-quantity'), 10);

    if (isNaN(qty) || isNaN(parseInt(line, 10))) return;

    // Prevent double-click
    btn.disabled = true;

    // Visual feedback: dim the line item being modified
    var lineItem = btn.closest('.brutal-mc__line-item');
    if (lineItem) lineItem.classList.add('brutal-mc--busy');
    if (qty === 0 && lineItem) lineItem.classList.add('brutal-mc--removing');

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(window.routes.cartChangeUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      updateBadge(cart.item_count);
      if (typeof updateCartShippingProgress === 'function') {
        updateCartShippingProgress(cart.total_price);
      }
      rerender();
    })
    .catch(function () {
      btn.disabled = false;
      if (lineItem) lineItem.classList.remove('brutal-mc--busy', 'brutal-mc--removing');
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    });
  });

  function addVariantToCart(variantId, options) {
    options = options || {};

    var cartAddUrl = (window.routes && window.routes.cartAddUrl) || '/cart/add';

    return fetch(cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Cart add failed');
      return r.json();
    })
    .then(function () {
      return fetch('/cart.js', { credentials: 'same-origin' });
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      updateBadge(cart.item_count);
      if (window.custom) window.custom.lastCartItem = cart.items[0] && cart.items[0].product_id;
      if (typeof updateCartShippingProgress === 'function') {
        updateCartShippingProgress(cart.total_price);
      }
      rerender();
      if (options.openDrawer !== false) open();
      return cart;
    });
  }

  /* ══════════════════════════════════════
     PRODUCT CARD ADD TO CART (AJAX)
     ══════════════════════════════════════ */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action="brutal-product-card-add"]');
    if (!btn) return;

    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.getAttribute('aria-disabled') === 'true') return;

    // Size quick-add buttons keep their size label and animate via class;
    // the full-width CTA swaps its text to ADDING\u2026/ADDED.
    var isSizeBtn = btn.classList.contains('brutal-card__size');
    var originalText = isSizeBtn ? null : btn.textContent;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('brutal-mc--busy');
    if (isSizeBtn) {
      btn.classList.add('brutal-card__size--adding');
    } else {
      btn.textContent = 'ADDING\u2026';
    }
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    addVariantToCart(variantId)
    .then(function () {
      if (isSizeBtn) {
        btn.classList.remove('brutal-card__size--adding');
        btn.classList.add('brutal-card__size--added');
      } else {
        btn.textContent = 'ADDED';
      }
      setTimeout(function () {
        btn.classList.remove('brutal-mc--busy', 'brutal-card__size--added');
        btn.removeAttribute('aria-disabled');
        if (!isSizeBtn) btn.textContent = originalText;
      }, 1200);
    })
    .catch(function () {
      btn.classList.remove('brutal-mc--busy', 'brutal-card__size--adding');
      btn.removeAttribute('aria-disabled');
      if (!isSizeBtn) btn.textContent = originalText;
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    });
  });

  /* ══════════════════════════════════════
     ADD UPSELL PRODUCT (AJAX)
     ══════════════════════════════════════ */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action="brutal-cart-add-upsell"]');
    if (!btn) return;

    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('brutal-mc--busy');
    btn.textContent = 'ADDING\u2026';
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    addVariantToCart(variantId)
    .catch(function () {
      btn.disabled = false;
      btn.classList.remove('brutal-mc--busy');
      btn.textContent = 'ADD';
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    });
  });

  /* ══════════════════════════════════════
     RE-RENDER FROM SECTION
     ══════════════════════════════════════ */

  function rerender() {
    var sectionId = 'brutal-cart-section';
    // Always use direct section render for fresh cart state.
    // Below-threshold upsells are populated separately via Storefront API.
    var url = window.location.pathname + '?section_id=' + sectionId + '&timestamp=' + Date.now();

    return fetch(url, { credentials: 'same-origin', method: 'GET' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;

        // Find the brutal cart inside the fetched HTML
        var freshDrawer = temp.querySelector('#brutal-cart') || temp.querySelector('.brutal-mc');
        if (freshDrawer && drawer) {
          // Preserve scroll position
          var body = drawer.querySelector('.brutal-mc__body');
          var scrollTop = body ? body.scrollTop : 0;

          drawer.innerHTML = freshDrawer.innerHTML;

          // AJAX events imply cart-view interaction; reset to cart view
          drawer.classList.remove('brutal-mc--view-wishlist');

          // Restore scroll
          var newBody = drawer.querySelector('.brutal-mc__body');
          if (newBody && scrollTop) newBody.scrollTop = scrollTop;

          // Re-populate dynamic blocks after re-render
          populateSocialProof();
          populateRecentlyViewed();

          // Update data-item-count
          if (freshDrawer.hasAttribute('data-item-count')) {
            var count = parseInt(freshDrawer.getAttribute('data-item-count'), 10);
            drawer.setAttribute('data-item-count', count);
            updateBadge(count);
          }

          // Populate Storefront API upsells if below threshold
          populateUpsells();
        }

        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      });
  }

  /* ══════════════════════════════════════
     BADGE UPDATE
     ══════════════════════════════════════ */

  function updateBadge(count) {
    // Update brutal cart count
    var c = drawer.querySelector('.brutal-mc__header-count') || document.getElementById('brutal-cart-count');
    if (c) c.textContent = count;

    // Update header badge (theme's cart count element)
    var headerBadge = document.querySelector('.header__cart-count');
    if (headerBadge) headerBadge.textContent = count;

    // Update total items text
    var totalItems = document.querySelector('.mini-cart-total-items');
    if (totalItems) totalItems.textContent = count + ' items';
  }

  /* ══════════════════════════════════════
     STOREFRONT API UPSELLS (below threshold)
     ══════════════════════════════════════ */

  var SF_TOKEN = (window.theme && window.theme.storefrontToken) || 'cd297553df7bc05064d96b95956428e9';
  var SF_API = '/api/' + ((window.theme && window.theme.storefrontApiVersion) || '2025-01') + '/graphql.json';

  function sfQuery(query, variables) {
    return fetch(SF_API, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': SF_TOKEN
      },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) { return r.json(); });
  }

  function fetchUpsells(remainingCents, cartProductIds) {
    var belowThreshold = remainingCents > 0;
    var handle = window.theme && window.theme.upsellCollection;
    var q, vars;

    if (handle) {
      if (belowThreshold) {
        // Collection with price filter — only products that cross the threshold
        var min = remainingCents / 100;
        q = 'query($h:String!,$min:Float!){collection(handle:$h){products(first:10,sortKey:PRICE,filters:[{available:true},{price:{min:$min}}]){nodes{id title vendor featuredImage{url(transform:{maxWidth:180})}variants(first:1){nodes{id price{amount}}}}}}}';
        vars = { h: handle, min: min };
      } else {
        // Above threshold — show first available from collection
        q = 'query($h:String!){collection(handle:$h){products(first:10,sortKey:BEST_SELLING,filters:[{available:true}]){nodes{id title vendor featuredImage{url(transform:{maxWidth:180})}variants(first:1){nodes{id price{amount}}}}}}}';
        vars = { h: handle };
      }
    } else {
      // No collection: use product recommendations
      var pid = (window.custom && window.custom.lastCartItem) || (cartProductIds[0] || '');
      if (!pid) return Promise.resolve([]);
      q = 'query($id:ID!){productRecommendations(productId:$id){id title vendor featuredImage{url(transform:{maxWidth:180})}variants(first:1){nodes{id price{amount}}}}}';
      vars = { id: 'gid://shopify/Product/' + pid };
    }

    return sfQuery(q, vars).then(function (res) {
      var products;
      if (handle) {
        products = (res.data && res.data.collection && res.data.collection.products.nodes) || [];
      } else {
        products = (res.data && res.data.productRecommendations) || [];
        if (belowThreshold) {
          // Filter recommendations by price >= remaining
          products = products.filter(function (p) {
            var v = p.variants.nodes[0];
            return v && parseFloat(v.price.amount) * 100 >= remainingCents;
          });
        }
        // Sort cheapest first
        products.sort(function (a, b) {
          return parseFloat(a.variants.nodes[0].price.amount) - parseFloat(b.variants.nodes[0].price.amount);
        });
      }
      // Exclude products already in cart
      return products.filter(function (p) {
        return cartProductIds.indexOf(p.id.replace('gid://shopify/Product/', '')) === -1;
      }).slice(0, 3);
    });
  }

  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var a = (cents / 100).toFixed(2);
    return fmt
      .replace('{{amount_with_comma_separator}}', a.replace('.', ','))
      .replace('{{amount_no_decimals}}', String(Math.round(cents / 100)))
      .replace('{{amount}}', a);
  }

  function esc(s) {
    var d = document.createElement('span');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function populateUpsells() {
    var el = drawer.querySelector('.brutal-mc__upsells-api');
    if (!el) return;

    var remaining = parseInt(el.getAttribute('data-remaining') || '0', 10);
    var belowThreshold = remaining > 0;
    var ids = (el.getAttribute('data-cart-products') || '').split(',').filter(Boolean);

    fetchUpsells(remaining, ids).then(function (products) {
      if (!products || !products.length) {
        el.innerHTML = '';
        return;
      }

      var headingText = el.getAttribute('data-heading') || 'You might also like';
      var h = '<div class="brutal-mc__upsell-heading">' + esc(headingText) + '</div>';

      products.forEach(function (p) {
        var v = p.variants.nodes[0] || {};
        var vid = (v.id || '').replace('gid://shopify/ProductVariant/', '');
        var cents = Math.round(parseFloat(v.price.amount) * 100);
        var img = p.featuredImage ? p.featuredImage.url : '';

        h += '<div class="brutal-mc__upsell-item">'
           + '<div class="brutal-mc__upsell-image">'
           + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" width="180" loading="lazy">' : '')
           + '</div>'
           + '<div class="brutal-mc__upsell-info">'
           + '<div class="brutal-mc__upsell-brand">' + esc(p.vendor) + '</div>'
           + '<div class="brutal-mc__upsell-title">' + esc(p.title) + '</div>'
           + '<div class="brutal-mc__upsell-price">' + formatMoney(cents) + '</div>'
           + '</div>'
           + '<button class="brutal-mc__upsell-add" data-action="brutal-cart-add-upsell" data-variant-id="' + vid + '" aria-label="Add ' + esc(p.title) + ' to cart"><svg viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M7 1v12M1 7h12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button>'
           + '</div>';
      });

      el.innerHTML = h;
    }).catch(function () {
      el.innerHTML = '';
    });
  }

  // Populate upsells on initial page load
  populateUpsells();

  /* ══════════════════════════════════════
     LISTEN FOR EXTERNAL EVENTS
     (product:added, cart:refresh from theme.js / custom.js)
     ══════════════════════════════════════ */

  document.addEventListener('product:added', function (e) {
    // Update count optimistically
    var currentCount = parseInt(drawer.getAttribute('data-item-count') || '0', 10);
    var addedQty = (e.detail && e.detail.quantity) || 1;
    updateBadge(currentCount + addedQty);

    // Re-render, then open drawer once DOM is updated
    rerender().then(function () {
      if (window.theme && window.theme.cartType === 'drawer' && window.theme.pageType !== 'cart') {
        open();
      }
    });
  });

  document.addEventListener('cart:refresh', function () {
    rerender();
  });

})();
